import { ReactNode, useCallback, useMemo } from 'react';
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard';
import extractTextContent from './extractTextContent';

interface UseCopyMessageResult {
  handleCopy: VoidFunction;
}

const useCopyMessage = (content: ReactNode): UseCopyMessageResult => {
  const copyText = useMemo(() => extractTextContent(content), [content]);
  const { copy } = useCopyToClipboard({ showSuccessToast: true, showErrorToast: true });

  const handleCopy = useCallback(() => {
    void copy(copyText);
  }, [copy, copyText]);

  return { handleCopy };
};

export default useCopyMessage;
